<template>
  <div :class="$style.container">
    <check-mark-icon v-m-right="10" v-fill:green />

    {{ $t('receipt.sent') }}

    <base-button
      autofocus
      @click="handleClick"
      v-color:violet
      v-m-left="10"
    >
      {{ $t('common.more') }}
    </base-button>
  </div>
</template>

<script>
import BaseButton from 'atoms/base/BaseButton';
import CheckMarkIcon from 'atoms/icons/basic/CheckMark';

export default {
  name: 'SuccessedSendReceipt',
  components: {
    BaseButton,
    CheckMarkIcon,
  },
  methods: {
    handleClick() {
      this.$emit('update', {
        email: '',
        status: 'INPUT',
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +align-items(center)
    +justify-content(space-around)
    +panel-in-card
    color: var(--color-black-2)
</style>
